<template>
  <div class="staking">
    <div class="container text-center">
      <router-link to="/dashboard">
        <i class="fa fa-chevron-left float-left" aria-hidden="true"></i>
      </router-link>
      <div class="head-title mb-10">
        <h2 class="text-black mb-0 pb-0">ShipYard</h2>
      </div>
      <br />
      <section v-if="stakes && loaded" class="mt-4">
        <div class="row">
          <Staked
            v-for="(item, index) in stakes"
            :key="index"
            :item="item"
            v-on:refresh-data="getStakes()"
          />
        </div>
      </section>
      <section>
        <div class="input_filter-box">
          <select
            class="form-select"
            aria-label="Default select example"
            @change="typeChange($event)"
          >
            <option value="captain" selected>Captain</option>
            <option value="ship">Ship</option>
          </select>
        </div>
      </section>
      <section class="staking-card_details">
        <div class="row justify-content-center">
          <Shipyard :type="type" :amount="15000" :days="3" />
          <Shipyard :type="type" :amount="45000" :days="3" />
          <Shipyard :type="type" :amount="135000" :days="3" />
          <Shipyard :type="type" :amount="400000" :days="3" />
          <Shipyard :type="type" :amount="10000" :days="5" />
          <Shipyard :type="type" :amount="30000" :days="5" />
          <Shipyard :type="type" :amount="90000" :days="5" />
          <Shipyard :type="type" :amount="270000" :days="5" />
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import Shipyard from "../components/Shipyard.vue";
import Staked from "../components/Staked.vue";
import ApiService from "../services";
export default {
  name: "Staking",
  components: {
    Shipyard,
    Staked,
  },
  data() {
    return {
      type: "captain",
      stakes: null,
      selectedTemp: null,
      loaded: false,
      timeLeft: 0,
    };
  },
  async created() {
    await this.getStakes();
  },
  methods: {
    typeChange(event) {
      this.type = event.target.value;
    },
    async getStakes() {
      this.loaded = false;
      ApiService.getStakes((res) => {
        this.stakes = res;
        this.loaded = true;
        return res;
      });
    },
  },
};
</script>

<style>
.textBlock h5 {
  font-size: 14px;
  font-weight: bold;
}
.mb-10 {
  margin-bottom: 10px;
}
.float-left {
  float: left;
}
.fa-chevron-left {
  margin-top: 10px;
  font-size: 28px;
  color: #fff;
}
</style>